import { prefix as clsPrefix } from '@/utils';

/**
 * 添加 classname 前缀
 * @param classname
 */
export default (classname) => {
  return {
    classname,
    prefix: clsPrefix(classname),
  };
};
